import React, { ReactNode } from "react";

import * as Styled from "./FilterButton.styles";

interface FilterButtonProps {
  title: string;
  isActive: boolean;
  onClick: () => void;
  icon?: ReactNode;
}

const FilterButton = ({ title, isActive, icon, onClick }: FilterButtonProps) => {
  return (
    <Styled.Root
      text={title}
      position={"bottom"}
    >
      <Styled.FilterButton
        onClick={onClick}
        $isActive={isActive}
      >
        {icon}
      </Styled.FilterButton>
    </Styled.Root>
  );
};

export { FilterButton };
